
import { Component, Ref, Vue } from "vue-property-decorator";
import { findIndex, isEmpty, get, lowerCase } from "lodash";
import Utils from "@/mixin";
import { Point as PointType, VForm } from "@/type";

@Component({
  props: {
    editId: {
      type: [Number, String],
      default: "",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    toggleDialog: {
      type: Function,
      // eslint-disable-next-line
      default: /* istanbul ignore next */ () => {},
    },
    setInitialDialog: {
      type: Function,
      // eslint-disable-next-line
      default: /* istanbul ignore next */ () => {},
    },
  },
  mixins: [Utils],
  computed: {
    validate() {
      const { brand, nameEN, nameTH, order, image } = this.formData;
      if (
        (this.editId === "" &&
          (isEmpty(brand) ||
            isEmpty(nameEN) ||
            isEmpty(nameTH) ||
            parseInt(order) === 0 ||
            image === undefined)) ||
        (this.editId !== "" &&
          (isEmpty(brand) ||
            isEmpty(nameEN) ||
            isEmpty(nameTH) ||
            parseInt(order) === 0))
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    editId(nextProps, prevProps) {
      /* istanbul ignore else */
      if (prevProps !== nextProps && nextProps !== "") {
        this.modalTitle = "Edit";
        const { pointList } = this;
        const index = findIndex(
          pointList,
          (i: PointType) => i.id === nextProps
        );
        const data = pointList[index];
        this.formData = {
          brand: data.brand,
          nameEN: data.NameEN,
          nameTH: data.nameTH,
          order: data.order,
          shopType: lowerCase(data.shopType),
        };
      }
    },
  },
})
export default class BrandForm extends Vue {
  modalTitle = "Create";
  initialForm = {
    brand: "",
    nameTH: "",
    nameEN: "",
    image: undefined,
    order: 0,
    shopType: "",
  };
  formData = {
    brand: "",
    nameTH: "",
    nameEN: "",
    image: undefined,
    order: 0,
    shopType: "",
  };
  shopItems = [
    { text: "Retail", value: "retail" },
    { text: "Wholesale", value: "wholesale" },
    { text: "Both", value: "both" },
  ];
  /* istanbul ignore next */
  rules = {
    required: (value: [number, string]) => !!value || "Required.",
    min: (value: number) => value > 0 || "Must more than 0",
  };

  @Ref("form") readonly form!: VForm;
  createBrand!: (formData: object) => void;
  editBrand!: (formData: object) => void;
  toggleDialog!: () => void;

  clearData() {
    if (this.$props.editId !== "") this.$props.setInitialDialog();
    this.toggleDialog();
    this.$nextTick(() => {
      this.modalTitle = "Create";
      this.formData = Object.assign({}, this.initialForm);
      /* istanbul ignore next */
      if (this.form) this.form.resetValidation();
    });
  }

  submitForm() {
    const { formData } = this;
    if (this.$props.editId !== "") {
      const submitForm = {
        brand: get(formData, "brand"),
        nameEN: get(formData, "nameEN"),
        nameTH: get(formData, "nameTH"),
        order: get(formData, "order").toString(),
        shopType: get(formData, "shopType"),
        image: formData.image,
        editId: this.$props.editId,
      };
      this.editBrand(submitForm);
    } else {
      const submitForm = {
        brand: get(formData, "brand"),
        nameEN: get(formData, "nameEN"),
        nameTH: get(formData, "nameTH"),
        order: get(formData, "order").toString(),
        shopType: get(formData, "shopType"),
        image: formData.image,
      };
      this.createBrand(submitForm);
    }
    this.clearData();
  }
}
